export default __webpack_public_path__ + "static/img3-17d2e22e0098880e17c939bbac06ec6f.jpg";